import { Record } from 'immutable'

export const SET_OWNER = 'SET_OWNER'

/**
 * Reducer section
 */
const initialState = {
  email: '',
  username: '',
  familyName: '',
  givenName: '',
  password: '',
  passwordConfirmation: '',
}

const Owner = new Record(initialState)

// FlowType
type Action = {
  type: string,
  payload: {
    owner: Owner,
  },
}

// FlowType
type Action = {
  type: string,
  payload: {},
}

export function reducer(state: Record = initialState, action: Action) {
  switch (action.type) {
    case SET_OWNER:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export function setOwner(payload: Owner) {
  return {
    type: SET_OWNER,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/owner.js